const initScrollAnimations = () => {

  // const observer = new IntersectionObserver((entries, observer) => {
  //   entries.forEach((entry) => {
  //     if (entry.intersectionRatio <= 0.5 && (entry.target.getBoundingClientRect().bottom < window.innerHeight)) {
  //       entry.target.classList.add('is-paint');
  //     } else {
  //       entry.target.classList.remove('is-paint');
  //     }
  //   });
  // }, {
  //   rootMargin: '50px',
  //   threshold: 0.5,
  // });

  // const paintBlocks = document.querySelectorAll('[data-paint]');

  // if (paintBlocks.length) {
  //   paintBlocks.forEach((item) => {
  //     observer.observe(item);
  //   });
  // }


  // svgs
  const conceptImage = document.querySelector('.concept__image');
  const graphs = document.querySelector('.technical-information__graphs');

  if (conceptImage) {
    const anims = document.querySelectorAll('.anim-path');

    conceptImage.addEventListener('sal:in', (e) => {
      anims.forEach((el) => {
        el.beginElement();
      });
    });
  }

  if (graphs) {
    const graphsAnims = document.querySelectorAll('.graph-anim');

    graphs.addEventListener('sal:in', (e) => {
      setTimeout(() => {
        graphsAnims.forEach((el) => {
          el.beginElement();
        });
      }, 500);
    });
  }
};

export {initScrollAnimations};
